import { createSelector } from "reselect";

export const profileSelector = (state) => state.profile;
export const profileListSelector = (state) => state.profileList;
export const errorsSelector = (state) => state.errors;
export const authSelector = (state) => state.auth;
export const alertSelector = (state) => state.alert;
export const popupOpenSelector = (state) => state.site.popupOpen;
export const currencySelector = (state) => state.site.currency;
export const patternSelector = (state) => state.pattern;
export const allPatternsSelector = (state) => state.allPatterns;
export const patternListSelector = (state) => state.patternList;
export const popupInnerSelector = (state) => state.site.popupInner;
export const localeSelector = (state) => state.locale.lang;
export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;
export const cartSelector = (state) => state.cart;
export const orderSelector = (state) => state.order;
export const orderDetailsSelector = (state) => state.orderDetails;
export const orderPaySelector = (state) => state.orderPay;
export const orderListSelector = (state) => state.orderList;
export const favouritesSelector = (state) => state.favourites;
export const paymentMethodSelector = (state) => state.payment;
export const usersListSelector = (state) => state.userList;
export const usersDeleteSelector = (state) => state.userDelete;
export const userDetailsSelector = (state) => state.userDetails;
export const userUpdateSelector = (state) => state.userUpdate;
export const patternReviewSelector = (state) => state.patternReview;

export const favouritesItemsSelector = createSelector(
  favouritesSelector,
  (items) => items.length
);
export const userDeleteSuccess = createSelector(
  usersDeleteSelector,
  (user) => user.success
);

export const userIdSelector = createSelector(
  authSelector,
  (items) => items && items._id
);

export const cartItemsSelector = createSelector(
  cartSelector,
  (items) => items.length
);

const toCents = (amount) => Math.round((Number(amount) || 0) * 100);

export const cartTotalPriceSelector = createSelector(cartSelector, (values) => {
  const totalCents = values.reduce((acc, val) => acc + toCents(val?.price), 0);
  return totalCents / 100;
});

export const userSelector = createSelector(authSelector, (auth) => auth.user);
export const userNameSelector = createSelector(
  userSelector,
  (user) => user && user.name
);

export const userIsAdminSelector = createSelector(
  userSelector,
  (user) => user && user.isAdmin
);
